<!-- eslint-disable vue/no-v-model-argument -->
<template>
  <div
    class="max-w-xl w-full rounded-lg sm:shadow-lg px-8 py-8 sm:my-2
                                                                    flex flex-col items-center justify-center"
  >
    <IconArrowLeft
      class="self-start cursor-pointer"
      @click="switchToLoginPanel"
    />

    <Logo class="place-self-end self-center -mt-6 mb-2" />

    <p class="text-2xl mb-8">
      {{ signUpMessages.title }}
    </p>

    <div
      v-if="!signUpSucced"
      class="flex-col justify-center w-80 space-y-4"
    >
      <Input
        v-model="user.email"
        type="email"
        name="email"
        autocomplete="email"
        autofocus
        :placeholder="$t('message.email_address') + $t('message.mandatory_char')"
        :error="emailError"
        :disabled="federatedSignIn && user.email"
      />

      <Input
        v-model="user.name"
        type="text"
        name="fname"
        autocomplete="given-name"
        :placeholder="$t('message.name') + $t('message.mandatory_char')"
        :error="nameError"
      />

      <Input
        v-model="user.surname"
        type="text"
        name="lname"
        autocomplete="family-name"
        :placeholder="$t('message.surname') + $t('message.mandatory_char')"
        :error="surnameError"
      />

      <PasswordInput
        v-if="!federatedSignIn"
        v-model="user.password"
        autocomplete="new-password"
        validate-password
        :placeholder="$t('message.password') + $t('message.mandatory_char')"
        :is-valid="isValidPassword"
        @update:isValid="updatePasswordStatus"
      />

      <PasswordInput
        v-if="!federatedSignIn"
        v-model="confirmPassword"
        autocomplete="new-password"
        :placeholder="$t('message.repeat_password') + $t('message.mandatory_char')"
        :error="!passwordsMatch"
      />

      <div class="flex flex-col justify-start space-y-2">
        <div class="flex flex-row items-center justify-start">
          <label
            class="mb-0 -mt-2 pt-3 pl-1 leading-tighter
                                                                    text-gray-600 cursor-text align-middle text-xs items-start"
          >{{
            $t('message.birthday') + $t('message.mandatory_char') }}</label>
        </div>

        <div class="flex flex-row items-center justify-between">
          <Select
            v-model="dayBirthdate"
            class="h-10"
            :default-selector-text="dayBirthdate"
            :options="dateCollector.days"
          />
          <Select
            v-model="monthBirthdate"
            class="h-10"
            :default-selector-text="monthBirthdate"
            :options="dateCollector.months"
          />
          <Select
            v-model="yearBirthdate"
            class="h-10"
            :options="dateCollector.years"
            :default-selector-text="defaultYearBirthdateText"
            :default-selector-value="defaultYearBirthdateValue"
          />
        </div>
      </div>


      <div class="flex flex-col justify-start items-start">
        <label
          class="mb-0 -mt-2 pt-3 pb-2 pl-1 leading-tighter
      text-gray-600 cursor-text align-middle text-xs"
        >{{ $t('message.phoneNumber') }}</label>

        <PhoneNumber
          id="tel"
          type="tel"
          name="tel"
          autocomplete="tel"
          @get-phone-number="($event) => phoneNumber = $event"
        />
      </div>

      <div class="flex flex-col justify-start items-start">
        <label
          class="mb-0 -mt-2 pt-5 pb-2 pl-1 leading-tighter
                                                              text-gray-600 cursor-text align-middle text-xs italic"
        >{{
          $t('message.mandatory_field') }}</label>
      </div>

      <div class="text-left">
        <span
          class="text-sm"
          v-html="$t('message.sign_up_general_conditions', { color: global.primaryColor, generalConditionsUrl: global.generalConditionsUrl })"
        />
        <span
          class="text-sm"
          v-html="$t('message.sign_up_vexatious_clauses')"
        />
        <br>
        <span
          class="text-sm"
          v-html="$t('message.sign_up_privacy_policy', {
            color: global.primaryColor, privacyUrl: global.privacyUrl
          })"
        />
      </div>

      <div class="border border-gray-200 rounded-full" />

      <!-- Marketing permission -->
      <div class="flex flex-row items-center justify-between">
        <label
          class="font-bold text-justify"
          v-html="signUpMessages.marketingTitle"
        />
        <Switch v-model:checked="acceptMarketingPermission" />
      </div>
      <div>
        <p class="text-justify text-sm">
          <span v-if="!marketingTextIsExpanded">
            {{ $t('message.marketing_consent_description_not_expanded') }}
            <span
              class="pl-2 font-bold underline cursor-pointer"
              :style="`color:${global.primaryColor}`"
              @click="marketingTextIsExpanded = !marketingTextIsExpanded"
            >
              <br>
              <div class="flex justify-end">{{ $t('message.read_more') }}</div>
            </span>
          </span>
          <span v-else>
            {{ $t('message.marketing_consent_description_expanded') }}
            <br>
            <span
              class="font-bold underline cursor-pointer flex justify-end"
              :style="`color:${global.primaryColor}`"
              @click="marketingTextIsExpanded = !marketingTextIsExpanded"
            >
              {{ $t('message.hide') }}
            </span>
          </span>
        </p>
      </div>

      <!-- <div class="border border-gray-200 rounded-full" /> -->
      <br>

      <!-- Profiling permission -->
      <div class="flex flex-row items-center justify-between">
        <label
          class="font-bold text-justify"
          v-html="signUpMessages.profilingTitle"
        />
        <Switch v-model:checked="acceptProfilingPermission" />
      </div>

      <div>
        <p class="text-justify text-sm">
          <span v-if="!profilingTextIsExpanded">
            {{ $t('message.profiling_consent_description_not_expanded') }}
            <span
              class="pl-2 font-bold underline cursor-pointer"
              :style="`color:${global.primaryColor}`"
              @click="profilingTextIsExpanded = !profilingTextIsExpanded"
            >
              <br>
              <div class="flex justify-end">{{ $t('message.read_more') }}</div>
            </span>
          </span>
          <span v-else>
            {{ $t('message.profiling_consent_description_expanded') }}
            <br>
            <span
              class="font-bold underline cursor-pointer flex justify-end"
              :style="`color:${global.primaryColor}`"
              @click="profilingTextIsExpanded = !profilingTextIsExpanded"
            >
              {{ $t('message.hide') }}
            </span>
          </span>
        </p>
      </div>

      <!-- Third permission -->
      <div class="flex flex-row items-center justify-between">
        <label
          class="font-bold text-justify"
          v-html="signUpMessages.thirdTitle"
        />
        <Switch v-model:checked="acceptThirdPermission" />
      </div>
      <div>
        <p class="text-justify text-sm">
          <span v-if="!thirdTextIsExpanded">
            {{ $t('message.third_consent_description_not_expanded') }}
            <span
              class="pl-2 font-bold underline cursor-pointer"
              :style="`color:${global.primaryColor}`"
              @click="thirdTextIsExpanded = !thirdTextIsExpanded"
            >
              <br>
              <div class="flex justify-end">{{ $t('message.read_more') }}</div>
            </span>
          </span>
          <span v-else>
            {{ $t('message.third_consent_description_expanded') }}
            <br>
            <span
              class="font-bold underline cursor-pointer flex justify-end"
              :style="`color:${global.primaryColor}`"
              @click="thirdTextIsExpanded = !thirdTextIsExpanded"
            >
              {{ $t('message.hide') }}
            </span>
          </span>
        </p>
      </div>

      <Button
        v-if="!federatedSignIn"
        class="w-80"
        :disabled="registrationButtonDisabled"
        @onClick="onSignUpPress"
      >
        {{ $t('message.register') }}
      </Button>

      <Button
        v-if="federatedSignIn"
        class="w-80"
        :disabled="federatedRegistrationButtonDisabled"
        @onClick="onFederatedSignUpPress"
      >
        {{ $t('message.register') }}
      </Button>

      <Message
        v-show="signUpError"
        class="w-full"
        :text="messageText"
        type="error"
      />
    </div>
    <Message
      v-show="signUpSucced"
      class="-mt-4 w-full sm:w-8/12"
      :text="$t('message.sign_up_email_sent', { email: user.email })"
    />
  </div>
</template>

<script lang="ts">
import Button from '@/components/atoms/Button.vue';
import Input from '@/components/atoms/Input.vue';
import moment from 'moment';
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import PhoneNumber from '@/components/atoms/PhoneNumber.vue';
import IconArrowLeft from '@/components/atoms/IconArrowLeft.vue';
import Logo from '@/components/atoms/Logo.vue';
import Message from '@/components/atoms/Message.vue';
import PasswordInput from '@/components/atoms/PasswordInput.vue';
import Select from '@/components/atoms/Select.vue';
import Switch from '@/components/atoms/Switch.vue';
import { ROUTES_NAMES } from '@/constants';
import { CognitoException } from '@/model/cognito';
import { dateCollector } from '@/model/date';
import { AppStatus } from '@/model/status';
import { User } from '@/model/user';
import { cleanUserFromCognito, getCurrentUser, revokeTokens, signUp } from '@/service/cognitoService';
import { federatedRegistration } from '@/service/crmService';
import { InputValidator } from '@/utils';

const ADULT_AGE = 18;

export default defineComponent({
  name: 'RegistrationPanel',
  components: {
    Button,
    Input,
    PhoneNumber,
    Select,
    Switch,
    Message,
    IconArrowLeft,
    Logo,
    PasswordInput
  },
  data() {
    return {
      user: {
        email: '',
        phoneNumber: '',
        password: '',
        name: '',
        surname: '',
        birthdate: '',
        profiling: '',
        marketing: '',
        third: '',
        clientId: ''
      } as User,
      phoneNumber: {
        countryCode: '',
        number: ''
      },
      confirmPassword: '',
      dayBirthdate: this.$t('message.dd'),
      monthBirthdate: this.$t('message.mm'),
      yearBirthdate: this.$t('message.yyyy'),
      defaultYearBirthdateText: this.$t('message.yyyy'),
      defaultYearBirthdateValue: this.$t('message.defaultYearBirthdate'),
      dateCollector: dateCollector,
      acceptProfilingPermission: false,
      acceptMarketingPermission: false,
      acceptThirdPermission: false,
      signUpSucced: false,
      signUpError: false,
      messageText: '',
      isValidPassword: false,
      federatedSignIn: false,
      username: '',
      countryCode: '',
      marketingTextIsExpanded: false,
      profilingTextIsExpanded: false,
      thirdTextIsExpanded: false
    };
  },
  computed: {
    ...mapGetters([
      'global',
      'signUpMessages',
      'clientID',
      'redirectURI'
    ]),

    passwordsMatch(): boolean {
      return this.user.password === this.confirmPassword;
    },
    emailError(): boolean {
      return this.user.email ? !InputValidator.validateEmail(this.user.email) : false;
    },
    nameError(): boolean {
      return this.user.name ? !InputValidator.validateName(this.user.name) : false;
    },
    surnameError(): boolean {
      return this.user.surname ? !InputValidator.validateSurname(this.user.surname) : false;
    },
    birthdateError(): boolean {
      return this.dayBirthdate === 'GG' || this.monthBirthdate === 'MM' || this.yearBirthdate === 'YYYY';
    },
    registrationButtonDisabled(): boolean {
      return !this.user.email ||
        !this.user.name ||
        !this.user.surname ||
        !this.user.password ||
        !this.isValidPassword ||
        !this.passwordsMatch ||
        this.emailError ||
        this.nameError ||
        this.surnameError ||
        this.birthdateError;
    },
    federatedRegistrationButtonDisabled(): boolean {
      return !this.user.email ||
        !this.user.name ||
        !this.user.surname ||
        this.emailError ||
        this.nameError ||
        this.surnameError ||
        this.birthdateError;
    }
  },
  async beforeMount() {
    if (this.$route.name === ROUTES_NAMES.federatedLogin) {
      this.federatedSignIn = true;
      try {
        const { username, attributes } = await getCurrentUser();
        this.username = username;
        this.user.email = attributes.email;
        this.user.name = attributes.name;
        this.user.surname = attributes.family_name;
      } catch (error) { }
    }
  },
  methods: {
    ...mapActions(['setAppStatus', 'setMyEmail', 'startLoading', 'endLoading']),

    async onSignUpPress() {
      try {
        this.messageText = '';
        this.signUpError = false;
        this.user.birthdate = this.formatBirthdate();
        if (!this.isValidBirthdate()) {
          this.messageText = this.$t('message.invalid_birthdate');
          this.signUpError = true;
          return;
        }
        if (!this.isValidAge()) {
          this.messageText = this.$t('message.under_age');
          this.signUpError = true;
          return;
        }
        if (this.phoneNumber.number) {
          this.user.phoneNumber = this.phoneNumber.countryCode + this.phoneNumber.number;
        }

        this.user.profiling = String(this.acceptProfilingPermission);
        this.user.marketing = String(this.acceptMarketingPermission);
        this.user.third = String(this.acceptThirdPermission);
        this.user.email = this.user.email.toLowerCase();
        this.user.name = this.user.name.toUpperCase();
        this.user.surname = this.user.surname.toUpperCase();
        this.startLoading();
        await signUp(this.user);
        this.signUpSucced = true;
      } catch (error: any) {
        this.signUpError = true;
        if (error.code === CognitoException.UsernameExistsException) {
          this.setAppStatus(AppStatus.UserAlreadyExists);
          this.switchToLoginPanel();
        } else if (error.code === CognitoException.InvalidPasswordException ||
          (error.code === CognitoException.InvalidParameterException && error.message.includes('password'))) {
          this.messageText = this.$t('message.invalid_password');
        } else if (error.code === CognitoException.UserLambdaValidationException &&
          error.message.includes(CognitoException.HatTrickSignUpException)) {
          this.messageText = this.$t('message.hat_trick_message');
        } else if (error.code === CognitoException.UserLambdaValidationException &&
          error.message.includes(CognitoException.CRMEmailExistedException)) {
          this.messageText = this.$t('message.crm_existing_email');
        } else if (error.code === CognitoException.UserLambdaValidationException &&
          error.message.includes(CognitoException.CustomMessageTriggerException)) {
          this.signUpSucced = true;
        } else if (error.code === CognitoException.InvalidParameterException &&
          error.message.includes(CognitoException.InvalidPhoneNumber)) {
          this.messageText = this.$t('message.invalid_phone_number');
        } else if (error.code === CognitoException.UserLambdaValidationException &&
          error.message.includes(CognitoException.CRMPhoneNotAllowed)) {
          this.messageText = this.$t('message.crm_phone_not_allowed');
        } else if (error.code === CognitoException.UserLambdaValidationException &&
          error.message.includes(CognitoException.CRMPhoneUsed)) {
          this.messageText = this.$t('message.crm_phone_used');
        } else if (error.code === CognitoException.UserLambdaValidationException &&
          error.message.includes(CognitoException.CRMPhoneNotCongruent)) {
          this.messageText = this.$t('message.crm_phone_not_congruent');
        } else if (error.code === CognitoException.UserLambdaValidationException &&
          error.message.includes(CognitoException.CRMIncongruentData)) {
          this.messageText = this.$t('message.crm_incongruent_data');
        } else {
          this.messageText = this.$t('message.sign_up_error');
        }
      } finally {
        this.endLoading();
        this.user.phoneNumber = '';
      }
    },
    async onFederatedSignUpPress() {
      try {
        this.messageText = '';
        this.signUpError = false;
        this.user.birthdate = this.formatBirthdate();
        if (!this.isValidBirthdate()) {
          this.messageText = this.$t('message.invalid_birthdate');
          this.signUpError = true;
          return;
        }
        if (!this.isValidAge()) {
          this.messageText = this.$t('message.under_age');
          this.signUpError = true;
          return;
        }
        if (this.phoneNumber.number !== '') {
          this.user.phoneNumber = this.phoneNumber.countryCode + this.phoneNumber.number;
        }

        this.user.clientId = this.clientID;
        this.user.profiling = String(this.acceptProfilingPermission);
        this.user.marketing = String(this.acceptMarketingPermission);
        this.user.third = String(this.acceptThirdPermission);
        this.user.email = this.user.email.toLowerCase();
        this.user.name = this.user.name.toUpperCase();
        this.user.surname = this.user.surname.toUpperCase();
        this.startLoading();
        await federatedRegistration(this.user, this.username);
      } catch (error: any) {
        this.signUpError = true;
        console.log(`TEST${error.response?.data?.message}`);
        if (error.response?.data?.message?.includes(CognitoException.HatTrickFederatedSignUpException)) {
          this.messageText = this.$t('message.hat_trick_message');
        }
        else if (error.response?.data?.message?.includes(CognitoException.CRMEmailExistedException)) {
          this.messageText = this.$t('message.crm_existing_email');
        }
        else if (error.response?.data?.message?.includes(CognitoException.CRMPhoneNotAllowed)) {
          this.messageText = this.$t('message.crm_phone_not_allowed');
        } 
        else if (error.response?.data?.message?.includes(CognitoException.CRMPhoneUsed)) {
          this.messageText = this.$t('message.crm_phone_used');
        } 
        else if (error.response?.data?.message?.includes(CognitoException.CRMPhoneNotCongruent)) {
          this.messageText = this.$t('message.crm_phone_not_congruent');
        } 
        else if (error.response?.data?.message?.includes(CognitoException.CRMIncongruentData)) {
          this.messageText = this.$t('message.crm_incongruent_data');
        } 
        else {
          this.messageText = this.$t('message.sign_up_error');
        }
      } finally {
        this.endLoading();
        this.user.phoneNumber = '';
      }
    },
    async switchToLoginPanel() {
      if (this.user.email) {
        this.setMyEmail(this.user.email);
      }

      if (this.federatedSignIn) {
        try {
          await cleanUserFromCognito();
        } catch (error) {
          console.error(error);
        }
        await revokeTokens();
        return this.$router.push({
          path: 'login',
          query: {
            client_id: this.clientID,
            redirect_uri: this.redirectURI
          }
        });
      }

      this.$router.push({
        path: 'login',
        query: { ...this.$route.query }
      });
    },
    formatBirthdate(): string {
      return this.$t('message.date_format', {
        day: Number(this.dayBirthdate) < 10 ? `0${this.dayBirthdate}` : this.dayBirthdate,
        month: Number(this.monthBirthdate) < 10 ? `0${this.monthBirthdate}` : this.monthBirthdate,
        year: this.yearBirthdate
      });
    },
    isValidBirthdate(): boolean {
      return moment(this.user.birthdate).isValid();
    },
    isValidAge(): boolean {
      return moment().diff(this.user.birthdate, 'years') >= ADULT_AGE;
    },
    updatePasswordStatus(isValid: boolean) {
      this.isValidPassword = isValid;
    }
  },
});
</script>
